import { setLatestSample } from "./latestData";
import { getLatestValues } from "../../services/valuesApi";

export async function fetchLatest(): Promise<boolean> {

    const latestValues = await getLatestValues();
    if (!latestValues) {
        return false;
    }
    for (const sample of latestValues) {
        setLatestSample(sample);
    }

    return true;
}
